import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * Recently Created Issues report route for CMP projects that do not have a board.
 */
export const cmpRecentlyCreatedBoardlessRoute: InvariantJiraRoute = {
	name: 'software-reports-recently-created-cmp-boardless',
	path: '/jira/software/c/projects/:projectKey/reports/recently-created',
};
